import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-data-buttons',
  templateUrl: './data-buttons.component.html',
  styleUrls: ['./data-buttons.component.scss']
})
export class DataButtonsComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }

}
